module.exports = __webpack_public_path__ + "static/media/machine-steam-homepage.4d483328.mp3";